import Table from '@/components/Table'
import { TableData } from '@/components/Table/type'
import { useImpedimentQuery } from '@/queries/useImpedimentQuery'
import { Impediment } from '@/types/Impediment'
import { createColumnHelper } from '@tanstack/react-table'
import { useMemo } from 'react'
import DadosMestreHeader from '../components/DadosMestreHeader' 
import DadosMestreHeaderActions from '../components/DadosMestreHeaderActions' 
import DefaultColumn from '@/components/Table/components/DefaultColumn'
import { useTable } from '@/hooks/useTable'
import { getLocaleDate } from '@/utils/date'
import DeleteDialog from './components/DeleteDialog'
import EditDialog from './components/EditDialog'
import AddDialog from './components/AddDialog'
import TableRowActions from '@/components/Table/components/TableRowActions'

export type ImpedimentTable = TableData<Impediment>

const columnHelper = createColumnHelper<Impediment>()

const MasterDataImpediment = () => {
    const {
        table, 
        selectedRow,
        selectedRows,
        isAddDialogOpen,
        isDeleteDialogOpen,
        isEditDialogOpen, 
        onAddDialogClose,
        onClickAdd,
        onClickDelete,
        onClickEdit,
        onClickMultiDelete,
        onDeleteDialogClose,
        onEditDialogClose,  
        setTable, 
    } = useTable<Impediment>('')
  
    const { data, isFetching, isPending, refetch } = useImpedimentQuery()
    
    const memoData = useMemo(() => data || [], [data])
    const memoColumns = useMemo(
        () => [
            columnHelper.accessor('DS_IMPEDITIVO', {
                id: 'DS_IMPEDITIVO',
                header: 'Impeditivo',
                size: 360,
            }), 
            columnHelper.accessor(({ CREATED_AT }) => 
                CREATED_AT ? getLocaleDate(CREATED_AT, 'dd/MM/yyyy HH:mm') : ''
            , { 
                cell: props => (
                    <p className="text-center w-full">{`${props.getValue() || ''}`}</p>
                ),
                id: 'CREATED_AT',
                header: 'Data de Criação',
                size: 150,
            }), 
            columnHelper.accessor(({ UPDATED_AT }) => 
                UPDATED_AT ? getLocaleDate(UPDATED_AT, 'dd/MM/yyyy HH:mm') : ''
            , {  
                cell: props => (
                    <p className="text-center w-full">{`${props.getValue() || ''}`}</p>
                ),
                id: 'UPDATED_AT',
                header: 'Data de Alteração',
                size: 150,
            }),
            columnHelper.display({
                id: 'Ações',
                cell: ({ row }) => { 
                    return (
                        (
                            <TableRowActions
                                onClickDelete={() => onClickDelete(row)}
                                onClickEdit={() => onClickEdit(row)}
                            />
                        )
                    )
                },
                size: 60,
                enableColumnFilter: false,
                enableSorting: false,
            }),
        ],
        []
    )
    
    return (
        <div className="w-full h-full p-4 overflow-hidden">
            <Table<ImpedimentTable>
                data={memoData}
                columns={memoColumns}
                getRowId={(row) => row.SK_IMPEDITIVO.toString()}
                isLoading={isPending}
                isFetching={isFetching}
                getTableInstance={(table) => setTable(table)} 
                tableHeader={
                    <DadosMestreHeader
                        title={`Impeditivos`}
                        onDelete={onClickMultiDelete}
                        selectedRows={
                            table
                                ?.getFilteredRowModel()
                                .flatRows.filter((row) => selectedRows[row.id])
                                .length
                        }
                    />
                }
                tableActions={
                    <DadosMestreHeaderActions 
                        onRefech={refetch}
                        onAdd={onClickAdd}
                    />
                } 
                defaultColumn={{
                    cell: ({ getValue }) => (
                        <DefaultColumn>{getValue() as string}</DefaultColumn>
                    ),
                }}
            /> 
            {isDeleteDialogOpen && (
                <DeleteDialog
                    ids={
                        selectedRow
                            ? [selectedRow.original.SK_IMPEDITIVO]
                            : table
                            ? table
                                  .getFilteredRowModel()
                                  .flatRows.filter(
                                      (row) => selectedRows[row.id]
                                  )
                                  .map((row) => row.original.SK_IMPEDITIVO)
                            : []
                    }
                    isOpen={isDeleteDialogOpen}
                    onClose={onDeleteDialogClose}
                />
            )}
            {selectedRow && (
                <EditDialog
                    row={selectedRow}
                    isOpen={isEditDialogOpen}
                    onClose={onEditDialogClose}
                />
            )}
            <AddDialog isOpen={isAddDialogOpen} onClose={onAddDialogClose} /> 
        </div>
    )
}

export default MasterDataImpediment
